import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { patientGoalXrefAll, selectedGoal, singleGoalData, chooseGoal, createGoal } from '../mockData/goals-data';

const GoalsApi = [
  rest.get(`${API_ROOT}patient-goals-xref`, (req, res, ctx) => {
    const type = req.url.searchParams.get('type');
    if (type === 'active') {
      return res(ctx.json({ active: patientGoalXrefAll.active }));
    }
    if (type === 'all') {
      return res(ctx.json(patientGoalXrefAll));
    }
    const goalCategoryId = req.url.searchParams.get('goalCategoryId');
    if (type === 'available' && goalCategoryId === '8') {
      return res(ctx.json(selectedGoal));
    }
    return res(ctx.json({ data: [] }));
  }),
  rest.get(`${API_ROOT}goal-categories`, (req, res, ctx) => {
    const categoriesWithGoals = req.url.searchParams.get('categoriesWithGoals');
    if (categoriesWithGoals !== 'true') {
      return res(ctx.json(singleGoalData));
    }
    if (categoriesWithGoals === 'true') {
      return res(ctx.json(chooseGoal));
    }
    return res(ctx.json({ data: [] }));
  }),
  rest.post(`${API_ROOT}patient-goals`, (req, res, ctx) => res(ctx.json(createGoal))),
  rest.patch(`${API_ROOT}patient-goals/${chooseGoal[0].patient_goals[0].id}`, (req, res, ctx) => res(ctx.json({ success: true }))),
];
export default GoalsApi;
